import { Component, OnInit } from '@angular/core';
import { settings } from '../../../shared/constants/settings';
import { ListComponent } from '../list.component';

@Component({
  selector: 'app-list-mobile',
  templateUrl: './list-mobile.component.html',
  styleUrls: ['./list-mobile.component.scss']
})
export class ListMobileComponent extends ListComponent implements OnInit {

  page: number = 0;
  moreData: boolean = true;

  ngOnInit(): void {
    this.loadLeads();

    super.init();
  }

  loadLeads() {
    this.page = 0;
    this.moreData = true;
    this.leads = [];

    this.appendLeads(); 
  }

  appendLeads() {
    if (!this.moreData) return;

    this.leadService.getList(this.filter, 'projectName', 'asc', this.page)
      .subscribe({
        next: (data) => {
          this.moreData = (data.length == settings.pageSize);
          data.forEach(d => this.leads.push(d));
        },
        error: (error: string) => this.onError(error)
      });
  }

  onScroll() {
    this.page++;

    this.appendLeads();
  }
}
